<template>
  <section>
    <h2>Комната 5: {{ this.$store.state.Window5.nameWindow5 }}</h2>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        class="d-flex justify-center pb-5"
      >
        <v-color-picker v-model="colorRoom5" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="d-flex justify-center"
      >
        <v-sheet
          :color="colorRoom5"
          height="304"
          width="300"
        >
        </v-sheet>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'ColorPickerRoom5',
  computed: {
    colorRoom5: {
      get () {
        return this.$store.state.Color.colorRoom5
      },
      set (value) {
        this.$store.commit('updateColorRoom5', value)
      }
    }
  }
}
</script>

<style>

</style>
